var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "dialog-class": _vm.modalClass,
      "hide-footer": _vm.isViewOnly,
      "centered": ""
    },
    on: {
      "shown": _vm.openForm,
      "hidden": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function () {
        return [_c('h4', {
          staticClass: "mb-0 text-primary"
        }, [_vm._v(" " + _vm._s(_vm.isViewOnly && _vm.isUpdate ? _vm.$t(_vm.detailTitle) : !_vm.isViewOnly && _vm.isUpdate ? _vm.$t(_vm.updateTitle) : _vm.$t(_vm.createTitle)) + " ")]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_vm.isUpdate && (!_vm.apiCode || _vm.isValidPermission(_vm.apiCode)) ? _c('ez-icon', {
          staticClass: "mr-1",
          class: {
            'cursor-pointer': _vm.disabledAndViewOnly
          },
          attrs: {
            "disabled": _vm.disableEditBtn,
            "icon": "ezAr-icon-edit",
            "size": "24",
            "color": _vm.disabledAndViewOnly ? '#ea5455' : '#ccc'
          },
          on: {
            "click": _vm.handleClickEdit
          }
        }) : _vm._e(), _c('ez-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "icon": "ezAr-icon-x",
            "size": "24",
            "color": "#114A9F"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('close');
            }
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function () {
        return [_c('LoadingModalButton', {
          ref: "buttonRef",
          attrs: {
            "is-modal-hidden": !_vm.isShow,
            "variant": "primary"
          },
          on: {
            "click": _vm.submitModal
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_common_save")))])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }